<template>
  <div class="content-item">
    <h2 class="heading">Name of Church</h2>
    <p class="text">As you would like it to appear on the card</p>
    <div class="form-group">
      <input v-model="church_name" type="text" name="textDemo" class="form-input" />
    </div>
  </div>
</template>

<script>
import { debounce, isFunction } from 'lodash';
import { empty } from '@/utils';
export default {
  name: 'Step3',
  props: {
    value: {
      type: Object,
    },
    source: {
      type: Object,
    },
    step: {
      type: Number,
    },
  },
  data() {
    return {
      church_name: '',
    };
  },
  computed: {
    isError() {
      return empty(this.church_name);
    },
  },
  watch: {
    isError: {
      handler(value) {
        if (isFunction(this.doEmitErrorDebouned)) {
          this.doEmitErrorDebouned(value);
        } else {
          this.doEmitError(value);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.doEmitErrorDebouned = debounce(this.doEmitError, 400);
  },
  methods: {
    submit() {
      if (this.isError) {
        this.$emit('onAnimated', [this.isError, this.step, 'Church name is required.']);
      } else {
        this.$emit('input', {
          ...this.value,
          church_name: this.church_name,
        });
      }
    },
    doEmitError(value) {
      this.$emit('onInvalid', [value, this.step, 'Church name is required.']);
    },
  },
};
</script>
